import { useState } from "react";
import DefaultButton from "../Buttons/Default";
import DefaultModal from "./Default";
import { API_URL } from "../../utils/constants";
import { toast } from "react-toastify";

function RepostPropertyModal({isOpen, toggle, onSuccess, propertyId}) {
  const [boostLoading, setBoostLoading] = useState(false);

  const boost = () => {
    setBoostLoading(true);
    fetch(API_URL+'/user/properties/repost/'+propertyId, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => response.json())
    .then(data => {
      if(data.success) {
        toast.success('تم إعادة نشر الإعلان بنجاح');

        onSuccess && onSuccess();
        toggle();
      } else {
        toast.error(data.message || 'حدث خطأ ما، يرجى المحاولة مرة أخرى');
      }
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .finally(() => {
      setBoostLoading(false);
    });
  }

  return(
    <DefaultModal
      isOpen={isOpen}
      toggle={toggle}
      size="md"
      title="إعادة نشر الإعلان"
    >
      <p className="text-center mb-3">
        أنت على وشك إعادة نشر الإعلان، سيتم الخصم من رصيد اعلاناتك. هل أنت متأكد من المتابعة؟
      </p>
      <div className="text-center">
        <DefaultButton 
          color="primary" 
          className="me-3 px-4" 
          onClick={boost}
          loading={boostLoading}
          disabled={boostLoading}
        >
          نعم
        </DefaultButton>
        <DefaultButton 
          color="danger" 
          className="px-4" 
          outline 
          onClick={toggle}
        >
          لا
        </DefaultButton>
      </div>
    </DefaultModal>
  );
}

export default RepostPropertyModal;